import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class GlobalAssetsService {
    private _assetsLocations = {
        external: 'assets',
        local: 'assets'
    };
    private readonly _isLocalAssets: boolean;
    private readonly _basePath: string;

    constructor() {
        this._isLocalAssets = false;
        // this._basePath =
        //     this._environmentService.environment.basePath !== ''
        //         ? this._environmentService.environment.basePath
        //         : this._appInfoService.AppInfo['environmentUrl'] || '';
        this._basePath = '';
    }

    public resolveAsset(file: string, localResource?: boolean): string {
        if ((this._isLocalAssets && localResource == null) || localResource === true) {
            return `${this._basePath}/${this._assetsLocations.local}/${file}`;
        } else {
            return `/${this._assetsLocations.external}/${file}`;
        }
    }
}
